<template>
  <div class="grid-container">
    <form :class="{'opacity-50': isWorking}" @submit.prevent="submit">
      <section-header size="xl" variants="dividing" class="mt-3">
        <heading level="1" size="xl">
          {{ $t('text.account.profile.updateEmail') }}
        </heading>
      </section-header>
      <p class="mb-3 text-base">
        {{ $t('text.account.profile.updateEmailAddress') }}
      </p>
      <pdl-callout v-if="message" :kind="messageType">
        <template #content>
          <span v-html="message" />
        </template>
      </pdl-callout>

      <div class="max-w-sm mb-6">
        <form-group
          ref="email"
          v-model="email"
          v-validate="'email|required'"
          type="email"
          name="email"
          :label="$t('profile.email')"
          :data-vv-as="$t('profile.email')"
          :error="errors.first('email')"
          :show-error-messages="true"
          required
        />
        <form-group
          v-model="chkEmail"
          v-validate="'email|required|confirmed:email'"
          type="email"
          name="chkEmail"
          :label="$t('profile.checkEmail')"
          :data-vv-as="$t('profile.checkEmail')"
          :error="errors.first('chkEmail')"
          :show-error-messages="true"
          required
        />
        <form-group
          v-model="password"
          v-validate="'required'"
          type="password"
          name="password"
          :label="$t('profile.pwd')"
          :data-vv-as="$t('profile.pwd')"
          :error="errors.first('password')"
          :show-error-messages="true"
          required
        />

        <div class="buttons">
          <trek-button primary type="submit" :disabled="isWorking" @click="submit">
            <span>{{ $t('text.account.profile.saveUpdates') }}</span>
          </trek-button>
          <trek-button secondary @click="cancel">
            <span>{{ $t('text.account.profile.cancel') }}</span>
          </trek-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import get from 'lodash/get';
import Heading from '@/components/Heading';
import {PdlCallout} from '@pedal/pdl-callout';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton';
import SectionHeader from '@/components/SectionHeader';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';

export default {
  name: 'UpdateEmailContainer',
  components: {Heading, PdlCallout, FormGroup, TrekButton, SectionHeader},
  extends: UserAccountBase,
  data() {
    return {
      email: '',
      chkEmail: '',
      password: '',
      isWorking: false,
    };
  },
  created() {
    const emitter = require('tiny-emitter/instance');
    emitter.on('langs-loaded', function () {
      this.useCustomPasswordValidationMessages({
        passwordField: 'password',
      });
    });
  },

  methods: {
    /**
     * Handle email update.
     * @return {Promise<void>}
     */
    async processUpdate() {
      this.isWorking = true;
      try {
        const response = await this.api.updateEmailAddress({
          email: this.email,
          chkEmail: this.chkEmail,
          password: this.password,
          CSRFToken: this.options.CSRFToken,
        });

        const isError = get(response.data.meta, 'feedback.type') !== 'success';
        const message = get(response.data.meta, 'feedback.message.basePropertyValue');
        this[isError ? 'displayError' : 'displaySuccess'](message);

        if (!isError) {
          this.resetForm();
        }
      } catch (e) {
        this.displayError(e.message);
      } finally {
        this.isWorking = false;
      }
    },

    /**
     * Reset form data.
     */
    resetForm() {
      this.email = '';
      this.chkEmail = '';
      this.password = '';
    },
  },
};
</script>
